import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";
import { queryParams } from "../../../utils/helper";

export const campaignApiService = createApi({
  reducerPath: "campaignApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getCampaignInternalList: builder.query({
      query: (params) => ({
        url: "campaign/internal/list",
        method: "GET",
        params,
      }),
      keepUnusedDataFor: 0,
    }),
    updateCampaignStatus: builder.mutation({
      query: ({ payload, params }) => {
        const query = queryParams(params);
        return {
          url: `campaign/${payload._id}${query}`,
          method: "PUT",
          body: payload,
        };
      },
    }),
  }),
});

export const {
  useGetCampaignInternalListQuery,
  useUpdateCampaignStatusMutation,
} = campaignApiService;
